import { getColor } from 'common/constants/_colors';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';

const ROWS_MAX_WIDTH = '100%';

export const ProjectRowsHeader = styled(Flex)`
  background: ${getColor('white')};
  width: 100%;
`;
export const HoverCell = styled.div`
  width: 100%;
  max-width: 20rem;
  height: 100%;
  background: ${getColor('darkBlue')};
  opacity: 0;
  ${({ isClickable }) => `cursor: ${isClickable ? 'pointer' : 'default'};`}
  ${({ isSelected }) => (isSelected ? `opacity: 0.04;` : `opacity: 0;`)};
`;

export const HoverWrapper = styled.div`
  ${({ width }) => `width: ${width};`}
  height: 100%;
  position: absolute;
  right: 2rem;
`;

export const ProjectRow = styled.div`
  position: relative;
  max-width: ${ROWS_MAX_WIDTH};
  height: 100%;
  ${({ loading }) =>
    loading &&
    `
  pointer-events: none;
  opacity: 0.5;
  z-index: 1;`}
`;

export const ProjectRowSection = styled(Flex)`
  max-width: ${ROWS_MAX_WIDTH};
`;
